import { z } from 'zod'

export const openUpdatesListSchema = z.object({
  masterTaskId: z.string(),
})
